import { render, staticRenderFns } from "./ContentRenderer.vue?vue&type=template&id=2159ce68&"
import script from "./ContentRenderer.vue?vue&type=script&lang=js&"
export * from "./ContentRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHeading: require('/server/itg-custom/production/front/components/SectionHeading.vue').default,UiSection: require('/server/itg-custom/production/front/components/UiSection.vue').default})
